<smrts-page primaryTitle="Regras de Conciliação Automática">

  <div header class="header-container">

    <div class="header-busca">
      <app-generic-autocomplete
        [items]="contas"
        displayField="nome"
        label="Buscar conta"
        inputId="contaSelecionada"
        [ngModel]="contaSelecionada"
        (selectionChange)="onContaSelecionada($event)">
      </app-generic-autocomplete>
    </div>

    <button mat-flat-button class="white-text-button btn-nova-regra" matTooltip="Nova regra" (click)="novoClick()"
      [disableNoPermission]="permissaoEditarRegra" [disabled]="novaRegraDesabilitada">
      <i class="pi pi-plus button-menu-icon"></i>
      <span class="btn-nova-regra-label">Nova regra</span>
    </button>

  </div>

  <div class="content">

    @if (contaSelecionada) {
      <mat-card class="main-card">
        <p-table [value]="regras" dataKey="id" class="regras-table">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="tipoVerificacao">Verificação<p-sortIcon field="tipoVerificacao"></p-sortIcon></th>
              <th pSortableColumn="termoBusca">Termo<p-sortIcon field="termoBusca"></p-sortIcon></th>
              <th pSortableColumn="tipoLancamentoOrigemNome">Origem<p-sortIcon field="tipoLancamentoOrigemNome"></p-sortIcon></th>
              <th pSortableColumn="tipoLancamentoDestinoNome">Destino<p-sortIcon field="tipoLancamentoDestinoNome"></p-sortIcon></th>
              <th pSortableColumn="loteLancamento">Lote<p-sortIcon field="loteLancamento"></p-sortIcon></th>
              <th pSortableColumn="observacao">Observação<p-sortIcon field="observacao"></p-sortIcon></th>
              <th style="width: 90px"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr>
              <td>{{ labelTipoVerificacao(item.tipoVerificacao) }}</td>
              <td>{{ item.termoBusca }}</td>
              <td>{{ item.tipoLancamentoOrigemNome }}</td>
              <td>{{ item.tipoLancamentoDestinoNome }}</td>
              <td>{{ item.loteLancamento }}</td>
              <td>{{ item.observacao }}</td>
              <td>
                <div class="acoes-coluna">
                  <button mat-icon-button [disableNoPermission]="permissaoEditarRegra" (click)="editarClick(item)">
                    <i class="pi pi-pencil"></i>
                  </button>
                  <button mat-icon-button [disableNoPermission]="permissaoEditarRegra" (click)="removerClick(item)">
                    <i class="pi pi-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="7">Nenhuma regra cadastrada para esta conta</td>
            </tr>
          </ng-template>
        </p-table>
      </mat-card>
    } @else {
      <mat-card class="main-card">
        <p>Busque uma conta para gerenciar suas regras de conciliação automática.</p>
      </mat-card>
    }


  </div>

</smrts-page>
